const dev = {
  path: 'https://testapi.growup.link'
}
module.exports = dev



// WEBPACK FOOTER //
// ./src/config/dev.js